export default class GameRunner {
	constructor() {
		this.looping = false
		this.preloaded = false
		this.paused = false
		this.frameRate = 30
		this.frameCount = 0
		this._lastFrameTime = window.performance.now()

		// store this bound function, so we don't have to create
		// one every single time we call requestAnimationFrame
		this.__loop = this._loop.bind(this)
	}

	async start() {
		if (!this.preloaded) {
			this.preload()
			this.preloaded = true
		}

		this.looping = true
		this.frameCount = 0

		window.requestAnimationFrame(this.__loop)
	}

	stop() {
		this.looping = false
	}

	pause() {
		this.paused = true
	}

	unpause() {
		this.paused = false;
		window.requestAnimationFrame(this.__loop)
	}

	_loop() {
		const now = window.performance.now()
		const timeSinceLast = now - this._lastFrameTime
		const targetTimeBetweenFrames = 1000 / this.frameRate

		if (timeSinceLast >= targetTimeBetweenFrames - 5) {
			this.onFrame()
			this._lastFrameTime = now
			this.frameCount++
		}

		if (this.looping && !this.paused) {
			window.requestAnimationFrame(this.__loop)
		}
	}
}
